import { Flex } from '@grupoboticario/flora-react';
import styled from 'styled-components';
import Text from 'styles/typography';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;

  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
`;

export const Title = styled(Text)`
  font-size: 20px;
  line-height: 74px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.mainDark};
`;

export const SidebarWrapper = styled(Flex)`
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.shape};

  padding: 22px;

  height: 243px;

  flex-direction: column;
`;

export const SidebarTitle = styled(Text)`
  font-size: 18px;
  padding-bottom: 18px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.title};
`;

export const Sidebar = styled.div`
  padding-bottom: 16px;

  ul {
    list-style: none;
    padding: 0;
  }

  li {
    cursor: pointer;
    padding: 10px;
    font-weight: 500;
    transition: background-color 0.2s;
  }

  li:hover {
    background-color: #eee;
  }

  li.selected {
    background-color: #f5f5f5;
    color: #000000;
  }

  .content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
  }
`;
